import GameContext from "../../common/context/game-context";
import { DefaultTennisConfig } from "../config/default";
import TennisGameContextSnapshot from "./tennis-game-context-snapshot";
import TennisTeamContext from "./tennis-team-context";

export default class TennisGameContext extends GameContext {
    constructor({
        gameId,
        ruleSetId,
        config = DefaultTennisConfig,
        gameClock,
        awayTeamId,
        homeTeamId
    } = {}) {
        super(gameId, ruleSetId, config);
        this.gameClock = gameClock;
        this.score = [0, 0];
        this.awayTeamId = awayTeamId;
        this.homeTeamId = homeTeamId;
        this.finalizeSettings = { finalizeOrder: { singles: [], doubles: [] } };
        this.winnerTeamId;
        this.gameInitialized = false;
    }

    _orderFinalizedMatchesByType(currentOrder, matches, isSingle) {
        const finalizedMatches = matches.filter(
            (match) => match.isSingle === isSingle
        );

        const newOrder = currentOrder.filter((matchId) =>
            finalizedMatches.find((match) => match.id === matchId)
        );

        const matchesNotOrdered = finalizedMatches.filter(
            (match) => !newOrder.find((matchId) => match.id === matchId)
        );

        return [...newOrder, ...matchesNotOrdered.map((m) => m.id)];
    }

    orderFinalizedMatches(finalizedMatches) {
        this.finalizeSettings.finalizeOrder.singles =
            this._orderFinalizedMatchesByType(
                this.finalizeSettings.finalizeOrder.singles,
                finalizedMatches,
                true
            );
        this.finalizeSettings.finalizeOrder.doubles =
            this._orderFinalizedMatchesByType(
                this.finalizeSettings.finalizeOrder.doubles,
                finalizedMatches,
                false
            );
    }

    generateSnapshot() {
        return new TennisGameContextSnapshot(this);
    }

    getTeamContext(teamId) {
        if (!this.teamContexts[teamId]) {
            this.teamContexts[teamId] = new TennisTeamContext(teamId);
        }

        return this.teamContexts[teamId];
    }

    setHomeScore(score) {
        this.score[0] = score;
    }

    setVisitorScore(score) {
        this.score[1] = score;
    }

    getHomeScore() {
        return this.score[0];
    }

    getVisitorScore() {
        return this.score[1];
    }

    isGameInitialized() {
        return this.gameInitialized;
    }
}
